import * as yup from 'yup';
import {
	firstNameSchema,
	lastNameSchema,
	emailIdSchema,
	passwordSchema,
	phoneNumberSchema,
	confirmPasswordSchema,
	confirmEmailIdSchema,
    companyNameSchema,
    usernameSchema
} from 'validations/common';

export const registerValidationSchema = yup.object().shape({
	firstName: firstNameSchema.nullable(),
	lastName: lastNameSchema.nullable(),
	phoneNumber: phoneNumberSchema.nullable(),
	emailId: emailIdSchema.nullable(),
	confirmEmailId:confirmEmailIdSchema.nullable(),
    password: passwordSchema.nullable(),
	confirmPassword: confirmPasswordSchema.nullable(),
	companyName: companyNameSchema.nullable(),
    username: usernameSchema.nullable(),
});
